var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2651 3.19475C11.0336 1.85482 12.9664 1.85482 13.7349 3.19475L20.6745 15.2941C21.4392 16.6274 20.4767 18.2891 18.9396 18.2891L5.06041 18.2891C3.52335 18.2891 2.56078 16.6274 3.32551 15.2941L10.2651 3.19475Z",
    fill: "#006363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2651 8.22795C11.0336 6.88803 12.9664 6.88803 13.7349 8.22796L16.3444 12.7776C17.1091 14.1109 16.1465 15.7727 14.6095 15.7727H9.39054C7.85347 15.7727 6.89091 14.1109 7.65564 12.7776L10.2651 8.22795Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.b06ad53c82ad513696b3c888601ca59d.svg";
export { ForwardRef as ReactComponent };